





import Vue from 'vue'
import moment from 'moment'

interface Props {
  filterValue: number
}

interface Computed {
  newFilterValue: string
}

export default Vue.extend<{}, {}, Computed, Props>({
  props: {
    filterValue: {
      required: true,
    },
  },
  computed: {
    newFilterValue: {
      get() {
        return moment
          .utc(this.filterValue * 1000)
          .local()
          .format('HH:mm:ss')
      },
      set(value) {
        this.$emit('input', moment.duration(value).asSeconds())
      },
    },
  },
  mounted() {
    this.newFilterValue =
      moment
        .utc(this.filterValue * 1000)
        .local()
        .format('HH:mm:ss') || '00:00:00'
  },
})
